/**
 * Admin Service
 * Centralized API calls for admin operations
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost/permataharapan-api/api';

// Content Management
export const contentService = {
  // List all contents
  listContents: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status_id) params.append('status_id', filters.status_id);
    if (filters.section_id) params.append('section_id', filters.section_id);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    const response = await fetch(`${API_BASE}/contents?${params}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Get single content
  getContent: async (id) => {
    const response = await fetch(`${API_BASE}/contents/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Create content
  createContent: async (data) => {
    const response = await fetch(`${API_BASE}/contents`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Update content
  updateContent: async (id, data) => {
    const response = await fetch(`${API_BASE}/contents/${id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Delete content
  deleteContent: async (id) => {
    const response = await fetch(`${API_BASE}/contents/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Update content status
  updateContentStatus: async (id, statusId, comment = '') => {
    const response = await fetch(`${API_BASE}/contents/${id}/status`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status_id: statusId, comment }),
    });
    return response.json();
  },

  // Get version history
  getVersionHistory: async (id) => {
    const response = await fetch(`${API_BASE}/contents/${id}/versions`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },
};

// Testimonials
export const testimonialService = {
  // List testimonials
  listTestimonials: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.author_type) params.append('author_type', filters.author_type);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    const response = await fetch(`${API_BASE}/testimonials?${params}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Get single testimonial
  getTestimonial: async (id) => {
    const response = await fetch(`${API_BASE}/testimonials/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Get testimonials stats
  getStats: async () => {
    const response = await fetch(`${API_BASE}/testimonials/stats`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Approve testimonial
  approveTestimonial: async (id) => {
    const response = await fetch(`${API_BASE}/testimonials/${id}/approve`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },

  // Reject testimonial
  rejectTestimonial: async (id, reason) => {
    const response = await fetch(`${API_BASE}/testimonials/${id}/reject`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason }),
    });
    return response.json();
  },

  // Toggle featured status
  toggleFeatured: async (id, featured) => {
    const response = await fetch(`${API_BASE}/testimonials/${id}/feature`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ featured }),
    });
    return response.json();
  },

  // Delete testimonial
  deleteTestimonial: async (id) => {
    const response = await fetch(`${API_BASE}/testimonials/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return response.json();
  },
};

// Status constants
export const CONTENT_STATUSES = {
  1: { name: 'Draft', color: '#6c757d', code: 'draft' },
  2: { name: 'Submitted', color: '#0dcaf0', code: 'submitted' },
  3: { name: 'Approved', color: '#198754', code: 'approved' },
  4: { name: 'Rejected', color: '#dc3545', code: 'rejected' },
  5: { name: 'Published', color: '#0d6efd', code: 'published' },
};

export const TESTIMONIAL_STATUSES = {
  pending: { name: 'Pending', color: '#ffc107', code: 'pending' },
  approved: { name: 'Approved', color: '#198754', code: 'approved' },
  rejected: { name: 'Rejected', color: '#dc3545', code: 'rejected' },
};
